// extracted by mini-css-extract-plugin
export default {"button":"grayButton_button__SJUPi"};